// src/utils/getIdToken.ts
import awsmobile from "../aws-exports";

const FALLBACK_CLIENT_ID =
  (awsmobile as any)?.aws_user_pools_web_client_id ||
  "1he2eeormri2phltjiigvpov44";

function parseCookies(): Record<string, string> {
  if (typeof document === "undefined") return {};
  const out: Record<string, string> = {};
  for (const part of document.cookie.split(";")) {
    const s = part.trim();
    if (!s) continue;
    const eq = s.indexOf("=");
    if (eq === -1) continue;
    const k = s.slice(0, eq);
    const v = s.slice(eq + 1);
    out[k] = v;
  }
  return out;
}

function findClientIds(cookieKeys: string[]): string[] {
  const ids = new Set<string>();
  for (const k of cookieKeys) {
    const m = k.match(/^CognitoIdentityServiceProvider\.([^.]+)\.LastAuthUser$/);
    if (m?.[1]) ids.add(m[1]);
  }
  return Array.from(ids);
}

export function getIdTokenFromCookie(): string {
  const cookies = parseCookies();
  const keys = Object.keys(cookies);

  const clientIds = findClientIds(keys);
  const clientId = clientIds[0] || FALLBACK_CLIENT_ID;

  const lastAuthUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;
  const lastUser = cookies[lastAuthUserKey]
    ? decodeURIComponent(cookies[lastAuthUserKey])
    : "";

  if (lastUser) {
    const idTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.idToken`;
    const v = cookies[idTokenKey];
    if (v) return decodeURIComponent(v);
  }

  const prefix = `CognitoIdentityServiceProvider.${clientId}.`;
  const anyIdTokenKey = keys.find(
    (k) => k.startsWith(prefix) && k.endsWith(".idToken")
  );
  if (anyIdTokenKey && cookies[anyIdTokenKey]) {
    return decodeURIComponent(cookies[anyIdTokenKey]);
  }

  const anyIdTokenKey2 = keys.find((k) => k.endsWith(".idToken"));
  if (anyIdTokenKey2 && cookies[anyIdTokenKey2]) {
    return decodeURIComponent(cookies[anyIdTokenKey2]);
  }

  return "";
}
